import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { APP_SETTINGS_HEADER_SHOW_VERSION_KEY, APP_SETTINGS_QUERY_KEY } from '@/config/appSettingsKeys'

/**
 * Global feature flag: show version (commit + date) in the header for moderators and admins.
 * Stored in app_settings; toggled in Admin → Feature flags.
 */
export function useHeaderShowVersionFlag() {
  const { data: value, isLoading } = useQuery({
    queryKey: [...APP_SETTINGS_QUERY_KEY, APP_SETTINGS_HEADER_SHOW_VERSION_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', APP_SETTINGS_HEADER_SHOW_VERSION_KEY)
        .maybeSingle()
      if (error) return false
      return data?.value === 'true'
    },
    staleTime: 60_000,
  })
  return { headerShowVersion: value ?? false, isLoading }
}
